import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface Props {
  onClick: () => void;
  label: string;
  ariaLabel: string;
  icon: React.ReactNode;
}

const MenuButton = ({ onClick, label, ariaLabel, icon }: Props) => {
  return (
    <Button
      onClick={onClick}
      variant="text"
      aria-label={ariaLabel}
      className="menuButton"
    >
      <Box
        role="presentation"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box
          display="flex"
          role="presentation"
          sx={{
            "& svg": {
              fontSize: "30px",
            },
          }}
        >
          {icon}
        </Box>
        <Box display="flex" role="presentation">
          <Typography>{label}</Typography>
        </Box>
      </Box>
    </Button>
  );
};

export default MenuButton;
